import React from 'react';
import MobileMenuItem from 'features/toolbar/toolbar/mobile/MobileMenuItem';
import { useLeaveBreakoutControl } from './useLeaveBreakoutControl';

const LeaveBreakoutControlMobile = () => {
  const { icon, label, handleAction, available } = useLeaveBreakoutControl();

  if (!available) {
    return null;
  }

  return (
    <MobileMenuItem data-testid="end-call-control" icon={icon} onClick={handleAction}>
      {label}
    </MobileMenuItem>
  );
};

export default LeaveBreakoutControlMobile;
